import React from 'react';

import BonusPagesList from '../BonusPage/BonusPagesList';
import { API_CASINO_DEPOSIT_BONUS_PAGES, API_CASINO_DEPOSIT_BONUS_PAGES_DELETE } from '../Helpers/CrmApiUrls';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import {
    CASINO_DEPOSIT_BONUS_PAGES_CREATE,
    CASINO_DEPOSIT_BONUS_PAGES_EDIT,
    CASINO_DEPOSIT_BONUS_PAGES_SHOW,
} from '../Helpers/CrmUrls';

function DepositBonusPagesList() {
    return (
        <BonusPagesList
            showUrl={CASINO_DEPOSIT_BONUS_PAGES_SHOW}
            createUrl={CASINO_DEPOSIT_BONUS_PAGES_CREATE}
            editUrl={CASINO_DEPOSIT_BONUS_PAGES_EDIT}
            deleteUrl={API_CASINO_DEPOSIT_BONUS_PAGES_DELETE}
            apiUrl={API_CASINO_DEPOSIT_BONUS_PAGES}
            createPermission={CRM_PERMISSION.CREATE_DEPOSIT_BONUS_PAGE}
            editPermission={CRM_PERMISSION.EDIT_DEPOSIT_BONUS_PAGE}
            deletePermission={CRM_PERMISSION.DELETE_DEPOSIT_BONUS_PAGE}
            showPermission={CRM_PERMISSION.SHOW_DEPOSIT_BONUS_PAGE}
            bonusIdColumn="casino_deposit_bonus_id"
            baseFrontLink={`${window.BASE_CASINO_URL}/promotions/deposit`}
        />
    );
}

export default DepositBonusPagesList;
